import styled from "styled-components";

export const HomeContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  background-color: #ffffff;
`;

// CSS Banner
export const BannerWrapper = styled.div`
  position: relative;
  width: 100%;
`;

export const Banner = styled.img.attrs({
  loading: "eager", // carrega logo de início
  decoding: "async", // não bloqueia renderização
})`
  width: 100%;
  min-height: 300px;
  object-fit: cover;
`;

export const BannerText = styled.h1`
  position: absolute;
  top: 50%;
  left: 25%;
  font-family: "Passion One", cursive;
  transform: translate(-50%, -50%);
  color: white;
  font-size: 4rem;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.7);

  @media (max-width: 1400px) {
    font-size: 3.5rem;
  }

  @media (max-width: 900px) {
    font-size: 3rem;
  }

  @media (max-width: 700px) {
    font-size: 2.5rem;
  }

  @media (max-width: 520px) {
    font-size: 1.9rem;
    left: 35%;
  }

  @media (max-width: 300px) {
    font-size: 1.5rem;
  }
`;

export const ContainerImg = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1% 10%;

  @media (max-width: 600px) {
    padding: 1% 5%;
  }

  img {
    width: 100%;
    height: auto;
  }
`;

export const InfoContainerUm = styled.div`
  display: flex;
  margin-top: 150px;
  flex-direction: column;
  padding: 1% 10%;

  @media (max-width: 600px) {
    padding: 1% 5%;
    margin-top: 80px;
  }
`;

// CSS Informações
export const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1% 10%;

  @media (max-width: 600px) {
    padding: 1% 5%;
  }
`;

export const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 30px;
  width: 100%;
  padding: 20px;

  @media (max-width: 700px) {
    grid-template-columns: 1fr;
    gap: 10px;
  }
`;

export const InfoCard = styled.div``;

export const InfoTitle = styled.h2`
  font-size: 2rem;
  font-weight: 900;
  font-family: "Montserrat", sans-serif;
  line-height: 90%;
  latter-spacing: 0;
  margin-bottom: 10px;
  color: #881c15;

  @media (max-width: 600px) {
    font-size: 1.5rem;
  }
`;

export const InfoText = styled.p`
  font-size: 1rem;
  font-family: "Montserrat", sans-serif;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 1.5;
  color: #606060;
  position: relative;

  &::before {
    position: absolute;
    left: 0;
    top: -15px;
    font-size: 2rem;
    line-height: 1.5;
    color: #606060;
  }

  @media (max-width: 600px) {
    font-size: 0.8rem;
  }
`;

// CSS Contatos e Selos
export const ContatosESelosContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #ffffff;
  width: 100%;

  padding: 20px 0;
`;

export const BoxTextContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 75%;
  background-color: #292929;
  padding: 30px 40px;
  border-radius: 10px;
  margin-top: 20px;

  @media (max-width: 600px) {
    flex-direction: column;
    gap: 20px;
    padding: 20px 20px;
    margin-top: 10px;
  }

  @media (max-width: 410px) {
    gap: 10px;
    padding: 10px 10px;
    margin-top: 10px;
  }

  h2 {
    font-size: 2rem;
    font-weight: 900;
    color: #ffffff;
    font-family: "Montserrat", sans-serif;
    line-height: 90%;
    letter-spacing: 0;
    margin: 0;
    margin-bottom: 10px;

    @media (max-width: 900px) {
      font-size: 1.5rem;
    }

    @media (max-width: 600px) {
      text-align: center;
    }

    @media (max-width: 410px) {
      font-size: 1.2rem;
    }

    @media (max-width: 330px) {
      font-size: 1rem;
    }
  }

  p {
    font-size: 1rem;
    color: #ff0000;
    letter-spacing: 0;
    line-height: 108%;
    font-family: "Montserrat", sans-serif;
    font-weight: 400;
    margin: 0;

    @media (max-width: 900px) {
      font-size: 0.8rem;
    }

    @media (max-width: 600px) {
      text-align: center;
    }

    @media (max-width: 410px) {
      font-size: 0.7rem;
    }
  }
`;

export const ButtonContatos = styled.button`
  background-color: #ffe1bc;
  color: #881c15;
  font-size: 1rem;
  font-weight: 600;
  line-height: 108%;
  letter-spacing: 0;
  font-family: "Montserrat", sans-serif;
  horizontal-align: center;
  vertical-align: middle;
  padding: 10px 80px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s;

  &:hover {
    background-color: #ffce93;
  }

  @media (max-width: 900px) {
    padding: 10px 20px;
  }

  @media (max-width: 410px) {
    padding: 8px 15px;
  }
`;

export const BoxImageContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
  width: 100%;
  justify-content: left;
  align-items: center;
  margin-top: 20px;
  margin-left: 20%;

  @media (max-width: 600px) {
    margin-left: 0;
    justify-content: center;
    gap: 10px;
  }
`;

export const BoxImageSisbi = styled.img.attrs({
  loading: "eager", // carrega logo de início
  decoding: "async", // não bloqueia renderização
})`
  max-width: 110px;

  @media (max-width: 600px) {
    max-width: 80px;
  }

  @media (max-width: 410px) {
    max-width: 70px;
  }
`;

export const BoxImageMaisIntegridade = styled.img.attrs({
  loading: "eager", // carrega logo de início
  decoding: "async", // não bloqueia renderização
})`
  max-width: 78px;

  @media (max-width: 600px) {
    max-width: 60px;
  }

  @media (max-width: 410px) {
    max-width: 50px;
  }
`;

export const BoxImageMapa = styled.img.attrs({
  loading: "eager", // carrega logo de início
  decoding: "async", // não bloqueia renderização
})`
  max-width: 128px;

  @media (max-width: 600px) {
    max-width: 100px;
  }

  @media (max-width: 410px) {
    max-width: 80px;
  }
`;
